import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';

import useEnrollmentUrl from '../../../hooks/useEnrollmentUrl';
import Button from '../../../components/button/Button';

import './howItWorksSection.scss';

export default function HowItWorksSection(props) {
  const {
    pretitle,
    title,
    subtitle,
    steps,
  } = props;

  const { enrollmentUrl } = useEnrollmentUrl();

  return (
    <section id="how-it-works" className="how_works">
      <div className="title-container">
        <p className="overline salmon">{pretitle}</p>
        <h2>{parse(title)}</h2>
        <h6>{subtitle}</h6>
      </div>

      <div className="cards-container">
        {steps.map((step, index) => (
          <div className="card" key={step.title}>
            <div className="card-number">{index + 1}</div>
            <img
              src={step.backgroundUrl}
              alt="hiw-background"
            />
            <div className="card-description">
              <h6>{step.title}</h6>
              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>

      <Button
        text="Get started"
        displayArrow
        dataAttr="CTA_clicked_how-works"
        className="blue"
        link={enrollmentUrl}
        target="_blank"
      />
    </section>
  );
}

HowItWorksSection.propTypes = {
  pretitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({
    backgroundUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })).isRequired,
};
